// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__JP-YH","button-container":"Button_button-container__c1Swi","button":"Button_button__w+JtY","button-span":"Button_button-span__GaVaP"};